import { createSlice } from '@reduxjs/toolkit';
import { allSteps, matchedStep, initialPlaceData, initialMainInfos, initialExtraInfos, initialLead } from './rentalFunnelInitialData';

export const initialState = () => {
  return {
    storeCreationTime: new Date(),
    allSteps: allSteps,
    currentStep: matchedStep(allSteps),
    estimationData: {
      placeData: initialPlaceData,
      typology: null,
      mainInfos: initialMainInfos,
      extraInfos: initialExtraInfos,
      priceExpectations: '',
      furnished: null,
      vacant: null,
      waitingTimePeriod: null,
      competition: null,
      lead: initialLead
    },
    errors: {},
    displayStreetNumberError: false
  }
};

export const rentalFunnelSlice = createSlice({
  name: 'rentalFunnel',
  initialState,
  reducers: {
    updateStep(state, { payload }) {
      state.errors = {}
      state.currentStep = state.allSteps.find(step => step.number === payload.stepNumber);
    },
    updateEstimationData(state, { payload }) {
      state.estimationData = payload;
    },
    purgeEstimationData(state) {
      const initialPayload = { ...initialState(), allSteps: state.allSteps, currentStep: state.allSteps[0]}
      Object.assign(state, initialPayload);
    },
    updateFullStore(state, { payload }) {
      state.estimationData = payload;
    },
    updateErrors(state, { payload }) {
      state.errors = payload;
      if (payload.street_number) state.displayStreetNumberError = true;
    },
    updateDisplayStreetNumberError(state, { payload }) {
      state.displayStreetNumberError = payload;
    }
  },
})

export const { updateStep, updateEstimationData, purgeEstimationData, updateErrors, updateFullStore, updateDisplayStreetNumberError } = rentalFunnelSlice.actions;

export default rentalFunnelSlice.reducer;
